import { FileInputPdf } from "../../../../common/components/form/FileInputPdf";
import { updateVehicleProps } from "../../../../common/services/vehicles.api";

type VehicleDocumentProps = {
  vehicleId: string;
  currentCRLVPath: string;
  currentNFPath: string;
  filesSale: string[] | undefined
  status: string;
}

export default function VehicleDocumentsRow(props: VehicleDocumentProps) {
  const pathToUpload = `vehicles/${props.vehicleId}`

  const saveVehicleCRLV = async (crlv) => {
    await updateVehicleProps(props.vehicleId, {
      crlv,
    })

  }

  const saveVehicleNF = async (nf) => {
    await updateVehicleProps(props.vehicleId, {
      nf,
    });
  }

  const saveFileSale = async (filesSale) => {
    await updateVehicleProps(props.vehicleId, {
      filesSale,
    });
  }

  return (
    <div className="col-span-3 bg-gray/40 p-4 rounded-md">
      <h2 className="text-2xl font-semibold mb-4">Enviar documentos do veículo</h2>
      <div className="flex flex-col items-stretch">
        <h3 className="font-bold ml-2">CRLV</h3>
        <FileInputPdf
          onChange={saveVehicleCRLV}
          pathToUpload={pathToUpload}
          currentPath={props.currentCRLVPath}
          nameFile="Enviar CRLV"
        />
        <h3 className="font-bold ml-2 mt-4">Nota Fiscal</h3>
        <FileInputPdf
          onChange={saveVehicleNF}
          pathToUpload={pathToUpload}
          currentPath={props.currentNFPath}
          nameFile="Enviar Nota Fiscal"
        />

        {props.status === 'selled' && typeof props.filesSale == 'string' &&
          <>
            <h3 className="font-bold ml-2 mt-4 ">Contrato/NF de Venda</h3>
            <FileInputPdf
              onChange={saveFileSale}
              pathToUpload={pathToUpload}
              currentPath={props.filesSale}
              nameFile="Enviar contrato/NF de Venda"
            />
          </>
        }
      </div>
    </div>
  )
}